export interface Storage {
  get(namespace: string, key: string): Promise<Uint8Array | null>;
  put(namespace: string, key: string, value: Uint8Array): Promise<void>;
  del(namespace: string, key: string): Promise<void>;
  /**
   * Alias for `del`. The JS SDK (`ping-openmls-sdk@0.2+`) calls
   * `storage.del`, while the RN-macOS binding
   * (`ping-openmls-sdk-react-native-macos@0.3+`) calls
   * `storage.delete`. Both hit the same Rust core with the same
   * semantics, so this adapter exposes both names off one impl.
   */
  delete(namespace: string, key: string): Promise<void>;
  listKeys(namespace: string): Promise<string[]>;
}

export interface PingStorageConfig {
  dbName?: string;
}

export abstract class PingStorage implements Storage {
  abstract get(namespace: string, key: string): Promise<Uint8Array | null>;
  abstract put(namespace: string, key: string, value: Uint8Array): Promise<void>;
  abstract del(namespace: string, key: string): Promise<void>;
  abstract listKeys(namespace: string): Promise<string[]>;
  abstract forgetSession(): Promise<void>;

  // Same operation, alternate spelling — see comment on `Storage.delete`.
  delete(namespace: string, key: string): Promise<void> {
    return this.del(namespace, key);
  }
}

export class StorageCorruption extends Error {
  readonly cause?: Error;

  constructor(message: string, cause?: Error) {
    super(message);
    this.name = 'StorageCorruption';
    if (cause !== undefined) {
      this.cause = cause;
    }
  }
}
